import { render, staticRenderFns } from "./document-type-picker.vue?vue&type=template&id=d6d69e0e&scoped=true&"
import script from "./document-type-picker.vue?vue&type=script&lang=js&"
export * from "./document-type-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d69e0e",
  null
  
)

export default component.exports